<template>
  <b-container fluid class="bg-light-gray h-100 pt-4">
    <b-jumbotron class="shadow p-5 mb-5 bg-white rounded mx-auto w-75 text-center">
      <h3 class="my-2">Terms and Conditions</h3>
      <div class="termsAndConditionContainer text-center my-4 p-2 div-2 border border-grey">
        <h4 class="text-primary">Welcome to your Online Testing with PhilPsyCor!</h4>
        <p>
          Please begin the assessment by reading the Terms of Service Provision, Privacy Policy, and Participant
          Agreement below. Kindly read the content carefully before submitting your personal data to us.
        </p>
        
        <h5 class="text-primary">Terms of Service Provision and Privacy Policy</h5>

        <p class="text-justify">
          This Service Provision and Privacy Policy covers the Materials and Services provided by the <b>Philippine
        Psychological Corporation</b> (PhilPsyCor). This site is available only to registered test takers of the
        accredited users of PhilPsyCor’s services. All of the content within this site is confidential and may not
        be reproduced, stored in a retrieval system, or transmitted in any form of media by any means, electronic,
        mechanical, photocopying, recording, or otherwise, without the written permission from PhilPsyCor:
        </p>
        <p class="text-justify">
          On this website, PhilPsyCor will be collecting information about you <u>for the purpose of</u> providing
        assessment services. You will be asked to provide basic information about yourself and asked to answer
        items that evaluate your abilities and/or personal qualities. <b>PhilPsyCor is committed to protect your
        privacy</b> and to guarantee that any personal data will be handled with care, without prejudice, and in
        accordance with the principles of the Philippines’ <b>Data Privacy Act of 2012 (RA 10173)</b>.
        </p>

        <h5 class="text-danger">Participant Agreement</h5>
        
        <p class="text-justify">
        By clicking on the “I AGREE” button below, you are agreeing to abide the PhilPsyCor’s Terms of
        Service Provision. If you do not wish to abide, you may click “I DISAGREE” and cancel the test.

        <ul>
        <li>You attest that you are an intended test taker referred by PhilPsyCor’s accredited test user.</li>
        <li>You agree to follow the administration procedures precisely and accomplish the test honestly without any assistance from anyone or anything else.</li>
        <li>You agree that you will not copy or share the copyrighted test items or content of this site.</li>
        <li>You agree not to disclose any of the contents of this site to any person except for authorized test administrators.</li>
        <li>You agree to enable PhilPsyCor to use your generated test data without your name and other personal information for the purpose of conducting research, including
        but not limited to the development of norms, evaluation of psychometric properties,
        and evaluation or improvement of our assessment tools for both PhilPsyCor’s own
        use and by the third parties.</li>
        </ul>
        </p>
      </div>
      <b-form>
        <b-button class="mx-auto w-50" @click="agree" variant="primary">I Agree</b-button><br>
        <b-button class="mx-auto w-50 mt-2" @click="disagree" variant="secondary">I Disagree</b-button>
      </b-form>
    </b-jumbotron>
  </b-container>
</template>

<script>
export default {
  name: "ExamineeTermsAndConditions",
  methods: {
    agree() {
      this.$store
        .dispatch("examinee/update", {
          id: this.$store.getters["user/roleId"],
          data: { status: "agreementsigned" },
        })
        .then(() => {
          return this.$router.push(`/examinee/info`);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    disagree() {
      const username = this.$store.getters[`user/username`];
      this.$store
        .dispatch(`user/logout`, { username })
        .then(() => {
          this.$router.push("/login");
        })
        .catch((err) => (this.loginError = err.message));
    },
  },
};
</script>

<style lang="css" scoped>
.termsAndConditionContainer {
  overflow-y: scroll;
  height: 45vh;
}
</style>